/**
 * Produces a stable, order-independent string key from the set of visible column
 * keys (the columns whose data is requested from the server).
 *
 * Used by `GridLifecycle` as a visible-set trigger so that toggling a column's
 * visibility triggers a data refetch — a newly shown column's data was never
 * fetched and must be loaded — while column reorder/resize/pin (which change
 * columnStates order but not the visible set) do NOT cause a spurious refetch.
 *
 * Mirrors `computeSortModelKey`.
 */
export const computeVisibleColumnsKey = (visibleColumnKeys: readonly string[]): string =>
  [...visibleColumnKeys].sort((a, b) => a.localeCompare(b)).join(',');
